import React, { useContext, useEffect, useState } from 'react';
import { HashRouter, Link, useLocation, Switch, Route } from 'react-router-dom';
import swal from 'sweetalert';
import { userContext } from '../../../contextProvider/Authentication';
import { getBase64 } from '../../../Functions/apis';
import axiosInstance from '../../../services/AxiosInstance';
import FileUpload from '../../Element/FileUpload';
import SavedJobs from './AppliedSavedJobs/SavedJobs';
import Feedback from './Feedback';
import CandidatePasswordChange from './Changepasswordpage';
import userImg from '../../../images/user.png';
import Jobsappliedjob from './AppliedSavedJobs/Jobsappliedjob';
import ConProfile from './Profile/ConProfile';
import Jobmyresume from './Resume/Jobmyresume';


const CandidateLayout = () => {
    let { pathname } = useLocation();
    const fullview = pathname.split('/').includes('jobs-my-resume');
    const [profileupdated, setProfileupdated] = useState(false);
    const { user, authenticated } = useContext(userContext);
    const [pimg, setPimg] = useState(() => {
        if (authenticated) {
            return localStorage.getItem('pimg');
        } else return null;
    });

    useEffect(() => {
        axiosInstance(
            "user/has_profile/", {
            method: "GET",
            data: {}
        }).then(res => {
            setProfileupdated(res.data.has_profile);
        })
    }, []);

    const handleImageChange = e => {
        let file = e.target.files[0];
        if (file.size < 1024000) {
            getBase64(file)
                .then(result => {
                    axiosInstance(`/user/${user?.id}/`, { method: "PATCH", data: { "pimg": result } });
                    localStorage.setItem("pimg", result);
                    setPimg(result);
                })
        }
        else swal("", "The Image size should be less than 1mb", "error", { button: "Ok!", })
    }

    return (
        <>
            <div className="page-content bg-white">
                <div className="content-block">
                    <div className="section-full bg-white browse-job p-t50 p-b20">
                        <div className="ml-5 mr-5">
                            <div className="row">
                                {/* SideBar */}
                                {
                                    !fullview &&
                                    <div className="col-xl-3 col-lg-4 m-b30">
                                        <div className="sticky-top">
                                            <div className="candidate-info">
                                                <div className="candidate-detail text-center">
                                                    <div className="canditate-des">
                                                        <Link to={'#'}>
                                                            <img alt="" src={pimg ? pimg : userImg} />
                                                        </Link>
                                                        <div className="upload-link" title="update" data-toggle="tooltip" data-placement="right">
                                                            <FileUpload
                                                                url={`/user/${user?.id}/`}
                                                                className="update-flie"
                                                                handleChange={handleImageChange}
                                                            />
                                                            <i className="fa fa-camera"></i>
                                                        </div>
                                                    </div>
                                                    <div className="candidate-title">
                                                        <div className="">
                                                            <h4 className="m-b5"><Link to={"#"}>{user?.first_name}</Link></h4>
                                                            {/* <p className="m-b0"><Link to={"#"}>Web developer</Link></p> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <ul>
                                                    <li><Link to={"/candidate/jobs-profile"} className={pathname === '/candidate/jobs-profile' ? 'active' : ''}>
                                                        <i className="fa fa-user-o" aria-hidden="true"></i>
                                                        <span>My Profile</span></Link></li>
                                                </ul>
                                                <ul className={!profileupdated ? 'custom-disabled' : ''}>
                                                    <li><Link to={"/candidate/jobs-my-resume"}>
                                                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                        <span>My Resume</span></Link></li>
                                                    <li><Link to={"/candidate/jobs-applied-job"} className={pathname === '/candidate/jobs-applied-job' ? 'active' : ''}>
                                                        <i className="fa fa-briefcase" aria-hidden="true"></i>
                                                        <span>Applied Jobs</span></Link></li>
                                                    <li><Link to={"/candidate/jobs-saved-jobs"} className={pathname === '/candidate/jobs-saved-jobs' ? 'active' : ''}>
                                                        <i className="fa fa-heart-o" aria-hidden="true"></i>
                                                        <span>Saved Jobs</span></Link></li>
                                                    <li><Link to={"/candidate/feedback"} className={pathname === '/candidate/feedback' ? 'active' : ''}>
                                                        <i className="fa fa-comments" aria-hidden="true"></i>
                                                        <span>Feedback</span></Link></li>
                                                    <li><Link to={"/candidate/candidate-change-password"} className={pathname === '/candidate/candidate-change-password' ? 'active' : ''}>
                                                        <i className="fa fa-key" aria-hidden="true"></i>
                                                        <span>Change Password</span></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* ------ SideBar ------- */}
                                {/* Components */}
                                <div className={`${fullview ? "col-xl-12" : "col-xl-9"} m-b30`} >
                                    <HashRouter>
                                        <Switch>
                                            <Route
                                                path="/candidate/jobs-profile"
                                                exact={true}
                                                component={ConProfile}
                                            />
                                            <Route
                                                path="/candidate/jobs-my-resume"
                                                exact={true}
                                                component={Jobmyresume}
                                            />
                                            <Route
                                                path="/candidate/jobs-applied-job"
                                                exact={true}
                                                component={Jobsappliedjob}
                                            />
                                            <Route
                                                path="/candidate/jobs-saved-jobs"
                                                exact={true}
                                                component={SavedJobs}
                                            />
                                            <Route
                                                path="/candidate/feedback"
                                                exact={true}
                                                component={Feedback}
                                            />
                                            <Route
                                                path="/candidate/candidate-change-password"
                                                exact={true}
                                                component={CandidatePasswordChange}
                                            />

                                            {/* <Route
                                                path="/jobs-profile"
                                                exact={true}
                                                component={ConProfile}
                                            /> */}
                                        </Switch>
                                    </HashRouter>
                                </div>
                                {/* ----- Components ----- */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CandidateLayout;